import React from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "src/components/ui/alert-dialog";
import { useDeletePropertyListing } from "../hooks/usePropertyListings";
import { useDeleteBuyerRequirement } from "../hooks/useBuyerRequirements";
import { useToast } from "src/components/ui/toast";

export function DeletePropertyModal({ open, onClose, record, type, onSuccess }) {
  const { toast } = useToast();

  const isListing = type === "listing";
  const deleteListing = useDeletePropertyListing();
  const deleteRequirement = useDeleteBuyerRequirement();

  const isPending = deleteListing.isPending || deleteRequirement.isPending;

  async function handleConfirm(e) {
    e.preventDefault();
    try {
      if (isListing) {
        await deleteListing.mutate(record.id);
        toast({ title: "Property deleted" });
      } else {
        await deleteRequirement.mutate(record.id);
        toast({ title: "Requirement deleted" });
      }
      onSuccess?.();
      onClose();
    } catch (err) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to delete record.",
      });
    }
  }

  return (
    <AlertDialog open={open} onOpenChange={(v) => !v && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete the{" "}
            {isListing ? "property listing" : "buyer requirement"} and remove its
            data from our servers.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={isPending}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            {isPending ? "Deleting..." : "Delete"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
